export default "__VITE_ASSET__CRTuAYza__"